import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import util from 'util';
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import DatePicker, { registerLocale } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import ja from 'date-fns/locale/ja';
import moment from 'moment';
import Common from '../Common/common.js';
registerLocale('ja', ja);

const Plan = (props) => {
  const { user, conditionActions } = props;
  const [planCategoryData, setPlanCategoryData] = useState([]);
  const [noticeIntervalMaster, setNoticeIntervalMaster] = useState([]);
  const [deliveryCompanyMaster, setDeliveryCompanyMaster] = useState([]);
  const [settingData, setSettingData] = useState([]);
  const [planData, setPlanData] = useState(null);
  const [lockData, setLockData] = useState(false);
  const { addToast } = useToasts()
  const [values, setValues] = useState({ plan_id: null, plan_name: '', plan_category_id: "0", remarks: "", planStart: null, planEnd: null, pdf_url: null, notice_id: "0", notice_type: "1", year_round_type: "0", upd_date: null, uploadfile: null, uploadfiletype: null, deletefile: null, payment_flag: "0", delivery_flag: "0", order_note_flag: "0", plan_order: null, delivery_company_id: "", delivery_price: 0});

  const refreshPlan = useCallback(async () => {
    const jwt = localStorage.getItem('jwt');
    const reg_params = {
      "site_id": props.match.params.siteId,
      "operator": "and",
      "where": [{ "site_id": props.match.params.siteId }]
    }
    const data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/plan/search/`, reg_params, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;
    data.sort((a, b) => a.plan_id - b.plan_id);
    setPlanData(data);

    const setting = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/setting/${props.match.params.siteId}`)).data;
    setSettingData(setting);

    const plancategory = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/plancategory/search/`, reg_params, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;
    setPlanCategoryData(plancategory);
    const deliverycompany = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/delivery_company/${props.match.params.siteId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`, 
      }
    })).data;
    setDeliveryCompanyMaster(deliverycompany);

    const noticeinterval = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/noticeinterval/search/`, reg_params, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;
    setNoticeIntervalMaster(noticeinterval);
    setValues({ plan_id: null, plan_name: '', plan_category_id: (plancategory.length > 0) ? plancategory[0].plan_category_id : "0", remarks: "", planStart: null, planEnd: null, pdf_url: null, notice_id: "0", notice_type: "1", year_round_type: "0", upd_date: null, uploadfile: null, uploadfiletype: null, deletefile: null, payment_flag: "0", delivery_flag: "0", order_note_flag: "0", plan_order: null, delivery_company_id: (deliverycompany.length > 0) ? deliverycompany[0].delivery_company_id : "0", delivery_price: 0 });
  }, [props.match.params.siteId])

  // 登録ボタン：処理
  const handlePlanRegistClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    const plan_start = moment(data.planStart).format("YYYYMMDD");
    const plan_end = moment(data.planEnd).format("YYYYMMDD");
    // 入力チェック
    if (!data.plan_name) {
      window.alert('企画名を入力してください。');
      return;
    }
    if (!data.planStart) {
      window.alert('受付開始日を入力してください。');
      return;
    }
    if (!data.planEnd) {
      window.alert('受付終了日を入力してください。');
      return;
    }
    if ( (!data.delivery_price) || (values.delivery_flag === constClass.FLAG.OFF)) {
      data.delivery_price = "0";
    }    
    if ( (!data.delivery_company_id) || (values.delivery_flag === constClass.FLAG.OFF)) {
      data.delivery_company_id = "0";
    }
    let res;
    try {
      setLockData(true);
      const form = new FormData();
      if (data.uploadfiletype) form.append("uploadfile", data.uploadfile);
      form.append("site_id", props.match.params.siteId);
      form.append("plan_id", data.plan_id);
      form.append("plan_category_id", data.plan_category_id);
      form.append("plan_name", data.plan_name);
      form.append("remarks", data.remarks);
      form.append("plan_start", plan_start);
      form.append("plan_end", plan_end);
      form.append("pdf_url", data.pdf_url);
      form.append("notice_id", data.notice_id);
      form.append("notice_type", data.notice_type);
      form.append("year_round_type", data.year_round_type);
      form.append("upd_date", data.upd_date);
      form.append("deletefile", data.deletefile);
      form.append("delivery_price", data.delivery_price);
      form.append("delivery_company_id", data.delivery_company_id);
      form.append("payment_flag", data.payment_flag);
      form.append("delivery_flag", data.delivery_flag);
      form.append("order_note_flag", data.order_note_flag);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/plan/`, form, {
        headers: {
          Authorization: `Bearer ${jwt}`,
          'content-type': 'multipart/form-data',
        }
      });
    } catch (err) {
      console.log(err);
      if (err.response.data !== null) {
        addToast(err.response.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshPlan();
      }
      setLockData(false);
      conditionActions.logout();
    }
  }

  // 削除ボタン：処理
  const handlePlanDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    if (data.product_count > 0) {
      window.alert('対象の企画に商品が登録されているため、削除できません。');
      return;
    }
    if (!window.confirm(`企画[${data.plan_id}:${data.plan_name}]を削除します。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: props.match.params.siteId,
      plan_id: data.plan_id,
      upd_date: data.upd_date,
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/plan/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('削除しました。', { appearance: 'success', autoDismiss: true });
        await refreshPlan();
      }
      setLockData(false);
      conditionActions.logout();
    }
  }

  // 編集ボタン：処理
  const handlePlanUpdateClick = (data) => {
    const startDate = new Date(data.plan_start.substr(0, 4) + '/' + data.plan_start.substr(4, 2) + '/' + data.plan_start.substr(6, 2));
    const endDate = new Date(data.plan_end.substr(0, 4) + '/' + data.plan_end.substr(4, 2) + '/' + data.plan_end.substr(6, 2));
    const remarks = data.remarks === null ? "" : data.remarks;
    var data2 = {
      plan_id: data.plan_id
      , plan_name: data.plan_name
      , plan_category_id: data.plan_category_id
      , remarks: remarks
      , planStart: startDate
      , planEnd: endDate
      , pdf_url: data.pdf_url
      , notice_id: data.notice_id
      , notice_type: data.notice_type
      , year_round_type: data.year_round_type
      , upd_date: data.upd_date
      , product_count: data.product_count
      , deletefile: null
      , uploadfiletype: null
      , payment_flag: data.payment_flag
      , delivery_flag: data.delivery_flag
      , delivery_price: data.delivery_price
      , delivery_company_id: data.delivery_company_id
      , order_note_flag: data.order_note_flag
    };
    if (data.pdf_url != null) data2.uploadfile = '/' + props.match.params.siteId + constClass.PLAN_IMAGE_DIR + data.pdf_url;
    else data2.uploadfile = null;
    setValues(data2);
  }

  // リセットボタン
  const handlePlanResetClick = () => {
    refreshPlan();
  }

  // value値変更イベント
  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setValues({ ...values, [name]: value });
  }

  // 「受取期間」変更イベント
  const handleChangeDate = (name, value) => {
    setValues({ ...values, [name]: value });
  }

  // 「企画PDF」変更イベント
  const handleChangeFile = (e) => {
    const value = e.target.files[0];
    var reader = new FileReader();
    reader.onload = () => {
      setValues({
        ...values,
        uploadfile: value,
        uploadfiletype: value.type,
        deletefile: values.pdf_url,
        uploadfiledata: URL.createObjectURL(value),
      });
    }
    reader.readAsDataURL(value);
  }

  // 「企画PDF」削除イベント
  const handleDeleteFile = () => {
    setValues({ ...values, uploadfile: null, uploadfiletype: null, deletefile: values.pdf_url });
  }

  // 編集ボタン
  const renderUpdateButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handlePlanUpdateClick(data)}>
        編集
      </button>
    )
  }

  // 登録ボタン
  const renderRegistButton = (data) => {
    return (
      <button type="button"
        disabled={lockData}
        className={`btn btn-primary mx-1`}
        onClick={() => handlePlanRegistClick(data)}>
        登録
      </button>
    )
  }

  // 削除ボタン
  const renderDeleteButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.plan_id === null}
        className={`btn btn-primary mx-1`}
        onClick={() => handlePlanDeleteClick(data)}>
        削除
      </button>
    )
  }

  // リセットボタン
  const renderResetButton = () => {
    return (
      <button type="button"
        disabled={lockData}
        className={`btn btn-primary mx-1`}
        onClick={() => handlePlanResetClick()}>
        リセット
      </button>
    )
  }

  // 初期実行トリガー
  useEffect(() => {
    async function fetchData() {
      await refreshPlan();
    }
    return fetchData();
  }, [refreshPlan]);


  return (
    <div className="container">
      <div className="row"><div className="col-12 h5">企画マスタメンテ</div></div>
      <div className="row d-none"><div className="col-12">{util.inspect(planData)}</div></div>
      <div className="row d-none"><div className="col-12">{util.inspect(user)}</div></div>
      {planData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {planData !== null && (
        <div className="row mb-3 p-0">
          <div className="col-12 p-0">
            <table className="table table-bordered table-striped">
              <thead className={`table-${constClass.COLOR[user.userClass]}`}>
                <tr>
                  <td className="text-center">
                    ID
                  </td>
                  <td className="text-center">
                    企画
                  </td>
                  <td className="text-center">
                    企画カテゴリ
                  </td>
                  <td className="text-center">
                    受付開始日
                  </td>
                  <td className="text-center">
                    受付終了日
                  </td>
                  <td className="text-center">
                    備考
                  </td>
                  <td className="text-center">
                    通年
                  </td>
                  <td className="text-center">
                    通知
                  </td>
                  <td className="text-center">
                    通知内容
                  </td>
                  <td className="text-center">
                    決済
                  </td>
                  <td className="text-center">
                    配送
                  </td>
                  <td className="text-center">
                    配送料
                  </td>
                  <td className="text-center">
                    配送会社
                  </td>
                  {Common.getSettingValue(settingData, 'ORDER_NOTE', '') === '1' &&
                    <td className="text-center">
                      備考欄
                    </td>
                  }
                  <td className="text-center">
                    更新日
                  </td>
                  <td className="text-center">
                    処理
                  </td>
                </tr>
              </thead>
              <tbody>
                {planData.map((data, idx) => (
                  <tr key={data.plan_id}>
                    {/* 企画ID */}
                    <td className="text-center align-middle">
                      {data.plan_id}
                    </td>
                    {/* 企画名 */}
                    <td className="text-center align-middle">
                      {data.plan_name}
                    </td>
                    {/* 企画カテゴリ名 */}
                    <td className="text-center align-middle">
                      {data.plan_category_id}:{data.plan_category_name}
                    </td>
                    {/* 受付開始日 */}
                    <td className="text-center align-middle">
                      {data.plan_start}
                    </td>
                    {/* 受付終了日 */}
                    <td className="text-center align-middle">
                      {data.plan_end}
                    </td>
                    {/* 備考 */}
                    <td className="text-center align-middle">
                      {data.remarks}
                    </td>
                    {/* 通年 */}
                    <td className="text-center align-middle">
                      {constClass.FLAG_MARK[data.year_round_type]}
                    </td>
                    {/* 通知 */}
                    <td className="text-center align-middle">
                      {data.notice_name}<br />
                    </td>
                    {/* 通知内容 */}
                    <td className="text-center align-middle">
                      {constClass.NOTICE_TYPE_NAME[data.notice_type]}<br />
                    </td>
                    {/* 決済 */}
                    <td className="text-center align-middle">
                      {constClass.FLAG_MARK[data.payment_flag]}
                    </td>
                    {/* 配送 */}
                    <td className="text-center align-middle">
                      {constClass.FLAG_MARK[data.delivery_flag]}
                    </td>
                    {/* 配送料 */}
                    <td className="text-center align-middle">
                      {Number(data.delivery_price).toLocaleString()}
                    </td>
                    {/* 配送会社 */}
                    <td className="text-center align-middle">
                    {data.delivery_company_name}
                    </td>
                    {/* 備考欄表示フラグ */}
                    {Common.getSettingValue(settingData, 'ORDER_NOTE', '') === '1' &&
                      <td className="text-center align-middle">
                        {constClass.FLAG_MARK[data.order_note_flag]}
                      </td>
                    }
                    {/* 更新日時 */}
                    <td className="text-center align-middle">
                      {data.upd_date ? moment(data.upd_date).format('YYYY-MM-DD HH:mm:ss') : ''}
                    </td>
                    {/* 処理 */}
                    <td className="text-center align-middle">
                      {renderUpdateButton(data)}
                    </td>
                  </tr>
                ))
                }
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div className="row mx-0">
        <div className="col px-0">
          <div className="row mb-3">
            <div className="col-2 text-center">
              <span>企画ID</span>
            </div>
            <div className="col-2">
              {values.plan_id !== null && values.plan_id}
              {values.plan_id == null && "新規"}
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center">
              <span className='needmark'>※</span>
                <span>企画名</span>
            </div>
            <div className="col-6">
              <input type="text" className="form-control" id="plan_name" name="plan_name" value={values.plan_name} onChange={handleChange} />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center">
              <span>企画カテゴリ</span>
            </div>
            <div className="col-6">
              <select className="form-control" id="plan_category_id" name="plan_category_id" value={values.plan_category_id} onChange={handleChange}>
                {planCategoryData.map((data2, idx) => (
                  <option key={data2.plan_category_id} value={data2.plan_category_id} >{data2.plan_category_name}</option>
                ))}</select>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center">
              <span>企画PDF</span>
            </div>
            <div className="col-6">
              {!(values.uploadfile) && <input type="file" className="form-control-file" name="pdfUrl" id="pdfUrl" value="" onChange={handleChangeFile} onClick={e => (e.target.value = null)} />}
              {values.uploadfile && <object id="uploadfileview" data={values.uploadfiledata || values.uploadfile} type={values.uploadfiletype}>File</object>}
              {values.uploadfile && <input type="button" className="form-controll" name="deletefile" id="deletefile" onClick={handleDeleteFile} value="ファイル削除" />}
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center">
              <span>備考</span>
            </div>
            <div className="col-6">
              <textarea className="form-control col-12" id="remarks" name="remarks" onChange={handleChange} value={values.remarks || ""} />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center">
              <span className='needmark'>※</span>
                <span>受付期間</span>
            </div>
            <div className="col-2">
              {<DatePicker className="form-control" aria_labal="受付開始日" locale="ja" dateFormat="yyyyMMdd" monthsShown="1" id="planStart" name="planStart" selected={values.planStart} onChange={date => handleChangeDate("planStart", date)} autoComplete="off" />}
            </div>
            <div className="col-1 w-50 text-center">
              ～
            </div>
            <div className="col-2">
              {<DatePicker className="form-control" aria_labal="受付終了日" locale="ja" dateFormat="yyyyMMdd" monthsShown="1" id="planEnd" name="planEnd" selected={values.planEnd} onChange={date => handleChangeDate("planEnd", date)} autoComplete="off" />}
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center">
              <span>通年設定</span>
            </div>
            <div className="col-1">
              <input type="checkbox" className="form-control" name="year_round_type" id="year_round_type" onChange={handleChange} value="1" checked={values.year_round_type === constClass.FLAG.ON} />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center">
              <span>注文通知頻度</span>
            </div>
            <div className="col-3">
              <select className="form-control" id="notice_id" name="notice_id" value={values.notice_id} onChange={handleChange}>
                {noticeIntervalMaster.map((data2, idx) => (
                  <option key={data2.notice_id} value={data2.notice_id} >{data2.notice_name}</option>
                ))}</select>
            </div>
          </div>
          {Number(values.notice_id) !== constClass.NOTICE_ID_FIXED.NONE &&
            <div className="row mb-3">
              <div className="col-2 text-center">
                <span>通知内容区分</span>
              </div>
              <div className="col-3">
                <select className="form-control" id="notice_type" name="notice_type" value={values.notice_type} onChange={handleChange}>
                  <option key={constClass.NOTICE_TYPE_NAME.COUNT} value={constClass.NOTICE_TYPE.COUNT}>{constClass.NOTICE_TYPE_NAME.COUNT}</option>
                  <option key={constClass.NOTICE_TYPE_NAME.DETAIL} value={constClass.NOTICE_TYPE.DETAIL}>{constClass.NOTICE_TYPE_NAME.DETAIL}</option>
                </select>
              </div>
            </div>
          }
          <div className="row mb-3">
            <div className="col-2 text-center">
              <span>事前決済フラグ</span>
            </div>
            <div className="col-2">
              {/* <input type="checkbox" className="form-control" id={'payment_flag'} name={'payment_flag'} checked={values.payment_flag === constClass.FLAG.ON} onChange={handleChange}></input> */}
              <select className="form-control" id="payment_flag" name="payment_flag" value={values.payment_flag} onChange={handleChange} disabled={Common.getSettingValue(settingData, 'PAYMENT_USE_FLAG', '0') ==='1' ? false : true}>
                <option key={constClass.FLAG.OFF} value={constClass.FLAG.OFF}>{constClass.FLAG_NAME.OFF}</option>
                <option key={constClass.FLAG.ON} value={constClass.FLAG.ON}>{constClass.FLAG_NAME.ON}</option>
                <option key={constClass.FLAG.BOTH} value={constClass.FLAG.BOTH}>{constClass.FLAG_NAME.BOTH}</option>
              </select>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center">
            <span>配送フラグ</span>
            </div>
            <div className="col-2">
              {/* <input type="checkbox" className="form-control" id={'delivery_flag'} name={'delivery_flag'} checked={values.delivery_flag === constClass.FLAG.ON} onChange={handleChange}></input> */}
              <select className="form-control" id="delivery_flag" name="delivery_flag" value={values.delivery_flag} onChange={handleChange} disabled={Common.getSettingValue(settingData, 'DELIVERY_USE_FLAG', '') ==='1' ? false : true}>
                <option key={constClass.FLAG.OFF} value={constClass.FLAG.OFF}>{constClass.FLAG_NAME.OFF}</option>
                <option key={constClass.FLAG.ON} value={constClass.FLAG.ON}>{constClass.FLAG_NAME.ON}</option>
                <option key={constClass.FLAG.BOTH} value={constClass.FLAG.BOTH}>{constClass.FLAG_NAME.BOTH}</option>
              </select>
            </div>
          </div>
          {values.delivery_flag !== constClass.FLAG.OFF &&
            <div className="row mb-3">
              <div className="col-2 text-center">
                <span>配送料</span>
              </div>
              <div className="col-2">
                <input type="text" className="form-control" id="delivery_price" name="delivery_price" value={values.delivery_price || ''} onChange={handleChange} />
              </div>
            </div>
          }
          {values.delivery_flag !== constClass.FLAG.OFF &&
            <div className="row mb-3">
              <div className="col-2 text-center">
                <span>配送会社</span>
              </div>
              <div className="col-3">
                <select className="form-control" id="delivery_company_id" name="delivery_company_id" value={values.delivery_company_id} onChange={handleChange}>
                  {deliveryCompanyMaster.map((data) => (
                    <option key={data.delivery_company_id} value={data.delivery_company_id}>{data.delivery_company_name}</option>
                  ))}
                </select>
              </div>
            </div>
          }
          {Common.getSettingValue(settingData, 'ORDER_NOTE', '') === '1' &&
          <div className="row mb-3">
            <div className="col-2 text-center">
            <span>備考欄表示フラグ</span>
            </div>
            <div className="col-2">
              {/* <input type="checkbox" className="form-control" id={'delivery_flag'} name={'delivery_flag'} checked={values.delivery_flag === constClass.FLAG.ON} onChange={handleChange}></input> */}
              <select className="form-control" id="order_note_flag" name="order_note_flag" value={values.order_note_flag} onChange={handleChange}>
                <option value="0">0:非表示</option>
                <option value="1">1:表示</option>
              </select>
            </div>
          </div>
          }
          <div className="row mb-3">
            <div className="col-2 text-center">
              {renderRegistButton(values)}
            </div>
            <div className="col-3 text-center">
              {renderDeleteButton(values)}
            </div>
            <div className="col-3 text-center">
              {renderResetButton(values)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Plan;